<template>
    <div class="underlay" @mousedown="underlayClick" v-if="modalSettings">
        <transition name="slide-fade">
            <div class="sidebar">
                <div class="sidebar_top">
                    <div @click="onCancelAction" class="close">
                        <img alt="Close" src="@/assets/icons/ic_close_white.svg">
                    </div>
                    <h2 class="sidebar_title">{{settings.title}}</h2>
                    <h3 class="sidebar_description" v-if="settings.description">{{settings.description}}</h3>
                    <form>
                        <ul class="sidebar_content">
                            <li>
                                <div class="icon-wrap">
                                    <img :src='require(`@/assets/icons/ic__.svg`)' alt="ico">
                                </div>
                                <div class="input-wrapper">
                                    <b-form-input placeholder=" " class="form-control" required type="text" :change="validateQuestion" list="my-list-id" v-model="settings.questionItem.value"></b-form-input>
                                    <label for="my-list-id" class="input-label">{{translate('own_EnterQuestion')}}</label>
                                    <datalist id="my-list-id">
                                        <option v-for="item in questionSuggestions" :key="item">{{ item }}</option>
                                    </datalist>
                                </div>
                                <div @click="onQuestionRightImageClick()" class="icon-wrap-right">
                                    <img :src='require(`@/assets/icons/ic_questions_autosuggest.svg`)' alt="ico">
                                </div>
                            </li>
                            <li>
                                <div class="icon-wrap">
                                    <img :src='require(`@/assets/icons/ic_house.svg`)' alt="ico">
                                </div>
                                <div class="input-wrapper">
                                    <b-form-input placeholder=" " class="form-control" required type="text" :change="validateQuestion" list="location-list" v-model="settings.locationItem.value"></b-form-input>
                                    <label for="location-list" class="input-label">{{translate('own_SpecifyLocation')}}</label>
                                    <datalist id="location-list">
                                        <option v-for="item in locationSuggestions" :key="item">{{ item }}</option>
                                    </datalist>
                                </div>
                            </li>
                            <li>
                                <div class="icon-wrap">
                                    <img :src='require(`@/assets/icons/ic_tag_asset_id.svg`)' alt="ico">
                                </div>
                                <div class="input-wrapper">
                                    <b-form-input placeholder=" " class="form-control" required type="text" v-model="settings.assetID.value"></b-form-input>
                                    <label for="location-list" class="input-label">{{translate('own_AssetId')}}</label>
                                </div>
                            </li>
                            <li>
                                <div class="icon-wrap">
                                    <img :src='require(`@/assets/icons/ic_happy.svg`)' alt="ico">
                                </div>
                                <div class="input-wrapper">
                                    <b-form-input placeholder=" " class="form-control" required type="text" v-model="settings.green.value" maxlength=12></b-form-input>
                                    <label for="location-list" class="input-label">{{translate('own_green')}}</label>
                                </div>
                            </li>
                            <li>
                                <div class="icon-wrap">
                                    <img :src='require(`@/assets/icons/ic_so_so.svg`)' alt="ico">
                                </div>
                                <div class="input-wrapper">
                                    <b-form-input placeholder=" " class="form-control" required type="text" v-model="settings.yellow.value" maxlength=12></b-form-input>
                                    <label for="location-list" class="input-label">{{translate('own_yellow')}}</label>
                                </div>
                            </li>
                            <li>
                                <div class="icon-wrap">
                                    <img :src='require(`@/assets/icons/ic_sad.svg`)' alt="ico">
                                </div>
                                <div class="input-wrapper">
                                    <b-form-input placeholder=" " class="form-control" required type="text" v-model="settings.red.value" maxlength=12></b-form-input>
                                    <label for="location-list" class="input-label">{{translate('own_red')}}</label>
                                </div>
                            </li>
                        </ul>
                    </form>
                </div>

                <div class="dropdown_sites" v-if="settings.dropdown">
                    <b-dropdown :text="dropdownChoose ? dropdownChoose.tag : settings.dropdown[0].tag">
                        <b-dropdown-item :key="index" v-for="(item, index) in settings.dropdown"
                                         v-on:click="changeDropdownActiveElement(item)">
                            <span>{{item.tag}}</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="sidebar_bottom">
                    <button :class="[{'disabled': btn.spinner}, btn.classList]" :disabled="btn.spinner" :key="index"
                            @click="onBtnAction(btn)" block
                            class="primaryButton"
                            v-for="(btn, index) in settings.buttons">
                        <b-spinner small v-if="btn.spinner"></b-spinner>
                        <span v-else>{{btn.text}}</span>
                    </button>
                    <button :class="settings.cancel.classList" @click="onCancelAction"
                            block
                            class="primaryButton reverse"
                            v-if="settings.cancel">
                        {{translate('Cancel')}}
                    </button>

                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import Vue from 'vue'
    import $ from 'jquery'
    import {mapActions, mapMutations} from 'vuex';
    import {MdField} from 'vue-material/dist/components'
    import '@/assets/css/MdField.css'
    import {validationMixin} from 'vuelidate'
    import _ from "lodash";
    import errorMixin from '@/mixins/errorMixin';
    import inviteManagers from '@/components/widgets/inviteManagers';
    import photoUploader from '@/components/widgets/photoUploader';
    import analyticFilter from '@/components/widgets/analyticFilter';
    import comments from '@/components/widgets/comments';
    import Autocomplete from 'v-autocomplete'
    import 'v-autocomplete/dist/v-autocomplete.css'
    import logAnalyticsEvent from '@/helpers/analytics'

    Vue.use(MdField)

    export default {
        name: 'customModalDialog',

        mixins: [errorMixin, validationMixin],

        data() {
            return {
                modalSettings: !_.isEmpty(this.settings),
                dropdownChoose: null,

                locationSuggestions: [],
                questionSuggestions: [],
                questionError: false
            }
        },

        components: {
            inviteManagers,
            analyticFilter,
            photoUploader,
            comments,
            Autocomplete,
        },

        watch: {
            settings(newValue) {
                this.modalSettings = !_.isEmpty(newValue)
                if (!_.isEmpty(this.settings)) {
                    this.reloadLocationSuggestions()
                    this.reloadQuestionSuggestions()
                }
                this.dropdownChoose = this.modalSettings.dropdownChoose
            },
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {
                        validate: true
                    }
                }
            },
        },

        methods: {
            ...mapActions({
                fetchLocationSuggestions: 'question/fetchLocationSuggestions',
                fetchQuestionSuggestions: 'question/fetchQuestionSuggestions',
            }),
            ...mapMutations({
                setSideBarToggle: 'owner/setSideBarToggle',
            }),


            async reloadLocationSuggestions() {
                try {
                    const response = await this.fetchLocationSuggestions()
                    if (response.success) {
                        this.locationSuggestions = response.hints
                    }
                } catch (e) {
                    console.log('error', e)
                } finally {

                }
            },
            async reloadQuestionSuggestions() {
                try {
                    const response = await this.fetchQuestionSuggestions()
                    if (response.success) {
                        var questions = response.top
                        response.templates.forEach(template => {
                            template.items.forEach(item => {
                                questions.push(item.text)
                            })
                        })
                        this.questionSuggestions = questions
                    }
                } catch (e) {
                    console.log('error', e)
                } finally {

                }
            },

            changeDropdownActiveElement(item) {
                this.dropdownChoose = item
                this.settings.dropdownChoose = item
            },

            validateQuestion() {
                let isValid = this.settings.questionItem.value
                if (isValid) {
                    this.questionError = false
                } else {
                    this.questionError = true
                }
                return isValid
            },

            async onCancelAction() {
                this.modalSettings = false
                this.setSideBarToggle(false)
                logAnalyticsEvent(`analytics_cancel_question_click`)
                this.dropdownChoose = null
                if (this.settings.onCancelAction) {
                    try {
                        await this.settings.onCancelAction(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            async onBtnAction(conf) {
                logAnalyticsEvent(`analytics_save_question_click`)
                if (!this.validateQuestion()) {
                    logAnalyticsEvent(`analytics_save_question_invalid`)
                    return
                }
                try {
                    await conf.action(this.settings)
                    if (conf.cleanData != false) {
                        this.modalSettings = false
                        this.dropdownChoose = null
                    }
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            },

            onQuestionRightImageClick() {
                if (this.settings.questionRightClickHandler) {
                    this.settings.questionRightClickHandler()
                }
            },
            underlayClick (e) {
                if (($(".underlay").has(e.target).length === 0)) {
                    if(this.modalSettings) this.onCancelAction()
                }
            }

        },
        mounted() {

        }
    }
</script>

<style>

    .sidebar_content .vti__input {
        background: none;
    }

    .sidebar_content .vti__dropdown {
        top: -2px;
    }

    .sidebar_content.vti__dropdown-item {
        width: 100%;
        margin: 0;
    }

    .sidebar_content .md-field .md-count,
    .sidebar_content .md-field .md-helper-text {
        color: #6D6D6D;
    }

    .dropdown_sites {
        position: relative;
        padding-left: 31px;
    }

    .dropdown_sites .btn-secondary,
    .dropdown_sites .btn-secondary:focus,
    .dropdown_sites .btn-secondary.focus {
        box-shadow: none !important;
        word-break: break-all;
        white-space: initial;
        text-align: left;
        padding-left: 0;
    }

    .dropdown_sites > .dropdown {
        width: 100%;
        max-width: 316px;
    }

    .dropdown_sites > .dropdown:before {
        content: " ";
        z-index: 1;
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: #3F405C;
        width: 100%;
        height: 1px;
    }

    .dropdown_sites .dropdown-toggle::after {
        position: absolute;
        right: 0;
    }

    .dropdown_sites .dropdown-menu.show {
        right: 0;
        left: 0;
        overflow-y: scroll;
        height: 150px;
        z-index: 99999;
    }

    .dropdown_sites .dropdown-menu.show li {
        width: 100%;
        margin: 0;
        padding: 0;
    }

    .dropdown_sites .dropdown-menu.show li a {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .dropdown_sites .dropdown-menu.show li a span {
        word-break: break-all;
        white-space: initial;
    }

    .dropdown_sites .dropdown-menu.show li a:active {
        background-color: #2F2F2F;
    }

    .dropdown_sites > .dropdown .btn-secondary {
        background: none !important;
        border: 0;
        display: flex;
        align-items: center;
        color: #2F2F2F;
        font-weight: 500;
        position: relative;
        font-size: 16px;
    }

    /* ## */

    .sidebar {
        height: 100vh;
        overflow-x: hidden;
        background: #fff;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        width: 400px;
        /*min-width: 350px;*/
        padding: 25px;
        z-index: 9999;
        box-shadow: -.5vw 0 .5vw 0 rgba(0, 0, 0, 0.25);
    }

    .sidebar .close {
        position: absolute;
        top: 0;
        right: 0;
    }

    .sidebar .close img {
        width: 17px;
        height: 17px;
    }

    .sidebar_top {
        position: relative;
        padding-top: 2vw;
    }

    .sidebar_title {
        font-size: 18px;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 30px;
    }

    .sidebar_description {
        font-size: 14px;
        line-height: 22px;
        margin-top: 1vw;
        margin-bottom: 1vw;
        font-weight: 700;
    }

    .sidebar_content li {
        display: flex;
        align-items: center;
        width: 100%;
        margin: 0;
        margin-bottom: 15px;
    }

    .sidebar_content .icon-wrap {
        min-width: 34px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .sidebar_content .icon-wrap-right {
        color: #2F2F2F;
        min-width: 28px;
        margin-left: 8px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border: 2px solid #2F2F2F;
        border-radius: 4px;
    }

    .sidebar_content li img {
        margin-right: 8px;
        max-width: 24px;
        max-height: 24px;
        opacity: .5;
    }

    .sidebar_content .icon-wrap-right img {
        margin-right: 0px;
        max-width: 20px;
        max-height: 20px;
        opacity: 1;
    }

    .sidebar_bottom {
        margin-top: 20px;
    }

    .sidebar_bottom button {
        width: 100%;
        margin-top: 5px;
    }

    .sidebar_bottom button.disabled {
        cursor: no-drop;
    }

    .md-field.md-invalid .md-error {
        color: red;
    }

    .md-helper-text .error {
        color: red;
    }

    .sidebar_content .md-field .md-input,
    .sidebar_content .md-field .md-textarea {
        font-size: 14px;
        line-height: 22px;
    }

    .sidebar_content .md-field .md-count {
        left: auto;
        right: 0;
    }

    .md-autocomplete-items li {
        display: flex;
        margin: 0px;
    }
    .input-label {
        position: absolute;
        z-index: 9999;
        top: 10px;
        pointer-events: none;
        transition: all .3s ease;
    }
    input {
        position: relative;
    }
    input:not(:placeholder-shown)~.input-label,
    input:focus~.input-label {
        top: -15px;
        transition: all .3s ease;
        font-size: 14px;
    }
    .input-wrapper {
        position: relative;
        width: 100%;
        margin-bottom: 15px;
    }
    .form-control {
        position: relative;
        border:none;
        border-bottom: 1px solid #2F2F2F;
        outline: none;
        border-radius: 0;
        padding-left: 0;
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        color: black;
    }
    .form-control:focus {
        outline: none !important;
        text-decoration: none;
        box-shadow: none;
        border-color: #2F2F2F;
        color: black;
    }
    input::-webkit-calendar-picker-indicator {
        display: none;
    }
    .form-control::placeholder {
        font-size: 14px;
        color: #2F2F2F;
    }

    .md-menu-content .md-theme-default {
        background: white;
    }

    .autocomplete .md-clear {
        display: none;
    }

    @media screen and (max-width: 1000px) {
        .sidebar {
            width: 97vw;
            padding: 25px 15px 10px;
            box-shadow: -10px 0 14px 0 rgba(0, 0, 0, 0.25);
        }

        .sidebar .close img {
            width: 24px;
        }

        .sidebar_top {
            padding-top: 30px;
        }

        .sidebar_title {
            font-size: 18px;
            margin-bottom: 30px;
        }

        .sidebar_content li {
            margin-top: 20px;
        }

        .sidebar_content .md-field .md-input {
            font-size: 16px;
            padding: 6px;
            height: auto;
        }

        .sidebar_content .md-field label {
            bottom: 0 !important;
            top: unset !important;
        }

        .sidebar_content .md-field.md-focused label,
        .sidebar_content .md-field.md-has-value label {
            font-size: 14px;
            top: unset !important;
            bottom: 23px !important;
        }

        .sidebar_content li img {
            margin-right: 7px;
            width: 22px
        }

    }
    @media screen and (max-width: 516px) {
        .sidebar_content li {
            margin-bottom: -20px;
        }
        .sidebar_title {
            margin-bottom: 10px;
        }
    }

</style>